export default {
  name: 'DashboardOrcamento',
  data() {
    return {
      tableHeader: [
        {
          name: this.$t('label.fluxo'),
          tooltip: this.$t('label.fluxo'),
          classes: [],
        },
        {
          name: this.$tc('label.tipo', 1),
          tooltip: this.$tc('label.tipo', 1),
          classes: [],
        },
        {
          name: this.$t('label.solicitante'),
          tooltip: this.$t('label.solicitante'),
          classes: [],
        },
        {
          name: this.$t('label.data_solicitacao'),
          tooltip: this.$t('label.data_solicitacao'),
          classes: [],
        },
        {
          name: this.$t('label.descricao'),
          tooltip: this.$t('label.descricao'),
          classes: [],
        },
        {
          name: this.$tc('label.valor', 1),
          tooltip: this.$tc('label.valor', 1),
          classes: [],
        },
        {
          name: '',
          classes: [],
        },
      ],
      stackData: {
        type: 'serial',
        theme: 'light',
        legend: {
          horizontalGap: 10,
          maxColumns: 1,
          position: 'right',
          useGraphSettings: true,
          markerSize: 10,
        },
        dataProvider: [{
          year: 2003,
          europe: 2.5,
          namerica: 2.5,
          asia: 2.1,
        }, {
          year: 2004,
          europe: 2.6,
          namerica: 2.7,
          asia: 2.2,
        }, {
          year: 2005,
          europe: 2.8,
          namerica: 2.9,
          asia: 2.4,
        }],
        valueAxes: [{
          stackType: 'regular',
          axisAlpha: 0.3,
          gridAlpha: 0,
        }],
        graphs: [{
          balloonText: '<b>[[title]]</b><br><span style="font-size:14px">[[categor]: <b>[[value]]</b></span>',
          fillAlphas: 0.8,
          labelText: '[[value]]',
          lineAlpha: 0.3,
          title: 'Europe',
          type: 'column',
          color: '#000000',
          valueField: 'europe',
        }, {
          balloonText: '<b>[[title]]</b><br><span style="font-size:14px">[[categor]: <b>[[value]]</b></span>',
          fillAlphas: 0.8,
          labelText: '[[value]]',
          lineAlpha: 0.3,
          title: 'North America',
          type: 'column',
          color: '#000000',
          valueField: 'namerica',
        }, {
          balloonText: '<b>[[title]]</b><br><span style="font-size:14px">[[categor]: <b>[[value]]</b></span>',
          fillAlphas: 0.8,
          labelText: '[[value]]',
          lineAlpha: 0.3,
          title: 'Asia-Pacific',
          type: 'column',
          color: '#000000',
          valueField: 'asia',
        }],
        categoryField: 'year',
        categoryAxis: {
          gridPosition: 'start',
          axisAlpha: 0,
          gridAlpha: 0,
          position: 'left',
        },
        export: {
          enabled: true,
        },
      },
    };
  },
  methods: {},
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/orcamento/orcamento.js